import type { ExperimentClient } from '@amplitude/experiment-js-client'
export interface IAnalyticsState {} // eslint-disable-line @typescript-eslint/no-empty-object-type

export interface IAnalyticsState {
    experiment: ExperimentClient | null
}

export const getInitialAnalyticsState = (): IAnalyticsState => {
    return {
        experiment: null,
    }
}

const moduleState = getInitialAnalyticsState()

export default moduleState
